import { ReactNode } from "react";
import { usePermissions } from "@/hooks/usePermissions";

interface PermissionGateProps {
  resource: string;
  action: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function PermissionGate({
  resource,
  action,
  children,
  fallback = null,
}: PermissionGateProps) {
  const { can } = usePermissions();

  if (!can(resource, action)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}

interface RequirePermissionProps {
  resource: string;
  action: string;
  children: ReactNode;
}

export function RequireViewPermission({
  resource,
  children,
}: Omit<RequirePermissionProps, "action">) {
  return (
    <PermissionGate resource={resource} action="view">
      {children}
    </PermissionGate>
  );
}

export function RequireCreatePermission({
  resource,
  children,
}: Omit<RequirePermissionProps, "action">) {
  return (
    <PermissionGate resource={resource} action="create">
      {children}
    </PermissionGate>
  );
}

export function RequireEditPermission({
  resource,
  children,
}: Omit<RequirePermissionProps, "action">) {
  return (
    <PermissionGate resource={resource} action="edit">
      {children}
    </PermissionGate>
  );
}

export function RequireDeletePermission({
  resource,
  children,
}: Omit<RequirePermissionProps, "action">) {
  return (
    <PermissionGate resource={resource} action="delete">
      {children}
    </PermissionGate>
  );
}
